module.exports = __webpack_public_path__ + "img/logo_printer_4.43306275.png";